import React from "react";
import { useEffect } from "react";

import "../styles/lavalamp.css";

const LavalampBlue = () => {
  const url = "blue-script.js"

  useEffect(() => {
    const script = document.createElement('script');
    script.src = url;
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    }
  }, [url]);
  return (
    <div className="blue_wrapper">
      <canvas
        id="bluebubble"
        style={{
          height: "100vh",
          width: "100vw",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      ></canvas>
    </div>
  );
};

export default LavalampBlue;
